module.exports = __webpack_public_path__ + "static/media/AssuranceService.f236a850.svg";